import * as React from 'react';
import styles from './DMS.module.css';

export const DmsDisplay = (props) => {
    const dms = props?.dms;
    const message = dms?.cmsMessage;
    const phases = message?.phases ?? [];
    const [phase, setPhase] = React.useState();
    const [phaseNum, setPhaseNum] = React.useState(0);
    const [timer, setTimer] = React.useState(null);

    const updatePhaseTimer = (phase) => {
        if(phases.length > 1) {
            const millisecs = phase?.phaseTime ? phase.phaseTime * 1000 : 1000;
            return setTimeout(() => {
                setPhaseNum(phaseNum => { return ++phaseNum })
            }, millisecs);
        }
        return null;
    }

    React.useEffect(() => {
        setTimer(updatePhaseTimer(phase));
    }, [])

    React.useEffect(() => {
        if(phases.length > phaseNum) {
            setPhase(phases[phaseNum]);
        } else {
            setPhaseNum(0);
        }
    }, [phaseNum])

    React.useEffect(() => {
        setTimer(timer => {
            clearTimeout(timer);
            return updatePhaseTimer(phase)
        });
    }, [phase])

    React.useEffect(() => {
        if(phases.length > 0) {
            setPhase(phases[0]);
        }
    },[message])

    const pageCns = getClassNamesForPages(message);

    // if(null !== phase) {
    // return (
    //      console.group(`Rendering phase #${phaseNum}`),
    //     console.log('Phase object:', phase),
    //     console.groupEnd(),
    //     <DmsPhase phase={phase} pageCns={pageCns} phaseNum={phaseNum} />
    // )
    // }
    if (phase != null) {
    return <DmsColumn phase={phase} pageCns={pageCns} phaseNum={phaseNum} />;
    }

    return null;

}

const pageTagsRegex = /\[*.p(.*?)\]/g;

const trRegex = /\[tr\s*([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+)\]/i;

// ---- New component: DmsColumn (add this below your other components) ----
const DmsColumn = ({ phase, pageCns, phaseNum }) => {
  if (!phase?.lines) return null;

  const columns = [];
  let currentCol = null;

  phase.lines.forEach((rawLine) => {
    let remaining = rawLine;
    let match;

    while ((match = trRegex.exec(remaining)) !== null) {
      const idx = match.index;
      const before = remaining.slice(0, idx);
      const after = remaining.slice(idx + match[0].length);

      if (currentCol === null) {
        currentCol = [];
        columns.push(currentCol);
        remaining = before + after;
      } else {
        currentCol.push(before);
        currentCol = [];
        columns.push(currentCol);
        remaining = after;
      }
    }

    if (currentCol === null) {
      currentCol = columns[0] || (columns[0] = []);
    }
    currentCol.push(remaining);
  });

  const lineCns = getClassNamesForLines(phase);

  const allText = phase.lines.join(" ");
  let justifyContent = "flex-end"; // default: right-aligned
  if (/\[jl3\]|\[jc\]/i.test(allText)) {
    justifyContent = "center";
  }

  return (
    <div className={getClassNames(pageCns, phaseNum, "dmsPhase")}>
      <div style={{ display: "flex", gap: "8px", justifyContent: justifyContent }}>
        {columns.map((colLines, ci) => (
          <div key={ci} style={{ display: "flex", flexDirection: "column" }}>
            {colLines.map((line, li) => (
              <DmsLine key={li} line={line} lineNum={li} cns={lineCns} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const DmsPhase = (props) => {
    const phase = props.phase;
    const cns = getClassNamesForLines(phase);
    const pageCns = props.pageCns;
    const phaseNum = props.phaseNum;

    console.group(`DmsPhase`);
    console.log('Lines received:', phase?.lines);
    console.log('Classnames per line:', cns);
    console.groupEnd();

    return (
        <div className={getClassNames(pageCns, phaseNum, "dmsPhase")}>
            {phase?.lines.map((line, idx) => {
                 console.log(
                    `Line[${idx}]:`,
                    line,
                    '→ classes:',
                    getClassNames(cns, idx, 'dmsLine')
                );
                return <DmsLine line={line} key={idx} lineNum={idx} cns={cns}/>
            })}
        </div>
    )
}

const DmsLine = (props) => {
    const line = props.line;
    const cns = props.cns;
    const lineNum = props.lineNum;
    const text = (line ?? "").replace(bracketsRegex, "");

    console.log(`DmsLine[${lineNum}] final text:`, text);

    return (
        <div className={getClassNames(cns, lineNum, "dmsLine")}>{text}</div>
    )
}


const lineTagsRegex = /\[*.l(.*?)\]/g;

const bracketsRegex = /\[(.*?)\]/g;

const removeBrackets = /[\[\]']+/g;

const getClassNamesForPages = (message) => {
    const classNames = [];
    message?.phases.forEach(phase => {
        classNames.push(convertTagsToClassNames(getTags(phase.markedUpText, pageTagsRegex)));
    })
    return classNames;
}

const getClassNamesForLines = (phase) => {
    const classNames = [];
    phase?.lines.forEach(line => {
        classNames.push(convertTagsToClassNames(getTags(line, lineTagsRegex)));
    })
    return classNames;
}

const convertTagsToClassNames = (tags) => {
    const cns = [];
    tags.forEach(tag => {
        const cn = tag.replace(removeBrackets, "");
        if(styles[cn]) {
            cns.push(styles[cn])
        } 
    })
    return cns;
}

const getClassNames = (cns, idx, defaultCn) => {
    var classNames = [styles[defaultCn]];
    console.log(cns);
    while(idx > -1) {
        if(cns[idx] && cns[idx].length > 0) {
            classNames = classNames.concat(cns[idx]);
            break;
        } else {
            --idx;
        }
    }
    return classNames.join(" ");
}

const getTags = (multi, regex) => {
    var tags = [];
    var found;
    while (found = regex.exec(multi)) {
        tags.push(found[0]);
    }
    return tags;
}